import * as types from './actionTypes';
import subscriptionsApi from '../api/subscriptionsApi';

export function loadSubscriptionsSuccess(subscriptions) {
  return {type: types.LOAD_SUBSCRIPTIONS_SUCCESS, subscriptions};
}

export function loadSubscriptions(deviceId, authToken) {  
  return function(dispatch) {
    return subscriptionsApi.getSubscriptions(deviceId, authToken).then(subscriptions => {
      dispatch(loadSubscriptionsSuccess(subscriptions));
    }).catch(error => {
      throw(error);
    });
  };
}

export function createSubscriptionsSuccess(subscriptions) {
	return {type: types.CREATE_SUBSCRIPTIONS_SUCCESS, subscriptions}
}

export function createSubscriptions(deviceId, authToken, stripeCustomerEmail, stripeTokenId, couponCode, products) {
	return function(dispatch) {
		return subscriptionsApi.createSubscriptions(deviceId, authToken, stripeCustomerEmail, stripeTokenId, couponCode, products).then(responseSubscriptions => {
			dispatch(createSubscriptionsSuccess(responseSubscriptions));
			return responseSubscriptions;
		}).catch(error => {
			throw(error);
		})
	}
}

export function updateCardDetailsSuccess(subscriptions) {
	return {type: types.UPDATE_CARD_DETAILS_SUCCESS, subscriptions}
}

export function updateCardDetails(deviceId, authToken, stripeCustomerEmail, stripeTokenId) {
	return function(dispatch) {
		return subscriptionsApi.updateCardDetails(deviceId, authToken, stripeCustomerEmail, stripeTokenId).then(responseSubscriptions => {
			dispatch(updateCardDetailsSuccess(responseSubscriptions));
			return responseSubscriptions;
		}).catch(error => {
			throw(error);
		})
	}
}

export function addProductsSuccess(subscriptions) {
	return {type: types.ADD_PRODUCTS_SUCCESS, subscriptions}
}

export function addProducts(deviceId, authToken, products) {
	return function(dispatch) {
		return subscriptionsApi.addProducts(deviceId, authToken, products).then(responseSubscriptions => {
			dispatch(addProductsSuccess(responseSubscriptions));
			return responseSubscriptions;
		}).catch(error => {
			throw(error);
		})
	}
}

export function removeProductsSuccess(subscriptions) {
	return {type: types.REMOVE_PRODUCTS_SUCCESS, subscriptions}
}

export function removeProducts(deviceId, authToken, products) {
	return function(dispatch) {
		return subscriptionsApi.removeProducts(deviceId, authToken, products).then(responseSubscriptions => {
			dispatch(removeProductsSuccess(responseSubscriptions));
			return responseSubscriptions;
		}).catch(error => {
			throw(error);
		})
	}
}

export function cancelSubscriptionsSuccess(subscriptions) {
	return {type: types.CANCEL_SUBSCRIPTIONS_SUCCESS, subscriptions}
}

export function cancelSubscriptions(deviceId, authToken) {
	return function(dispatch) {
		return subscriptionsApi.cancelSubscriptions(deviceId, authToken).then(responseSubscriptions => {
			dispatch(cancelSubscriptionsSuccess(responseSubscriptions));
			return responseSubscriptions;
		}).catch(error => {
			throw(error);
		})
	}
}

export function reactivateSubscriptionsSuccess(subscriptions) {
	return {type: types.REACTIVATE_SUBSCRIPTIONS_SUCCESS, subscriptions}
}

export function reactivateSubscriptions(deviceId, authToken) {
	return function(dispatch) {
		return subscriptionsApi.reactivateSubscriptions(deviceId, authToken).then(responseSubscriptions => {
			dispatch(reactivateSubscriptionsSuccess(responseSubscriptions));
			return responseSubscriptions;
		}).catch(error => {
			throw(error);
		})
	}
}




// WEBPACK FOOTER //
// ./src/actions/subscriptionsActions.js